import { Placement } from '../../../shared/design-system/components/overlay';

export const getShortenedFileName = (fileName: string) => {
  if (!fileName) return '';
  // Remove file extension
  const nameWithoutExt = fileName?.replace(/\.[^/.]+$/, '');
  // Trim only leading/trailing spaces
  const trimmed = nameWithoutExt.trim();

  return trimmed.length > 36 ? `${trimmed.slice(0, 29)}...` : trimmed;
};

export const getProgressPopoverSections = (item) => [
  {
    label: 'Valid',
    iconClass: 'valid-icon',
    count: item?.statusContactsCount?.validContacts?.count,
    percentage: item?.statusContactsCount?.validContacts?.percentage,
  },
  {
    label: 'Invalid',
    iconClass: 'invalid-icon',
    count: item?.statusContactsCount?.invalidContacts?.count,
    percentage: item?.statusContactsCount?.invalidContacts?.percentage,
    children: [
      {
        label: 'Spam Trap',
        count: item?.statusContactsCount?.spamTrapContacts?.count,
        percentage: item?.statusContactsCount?.spamTrapContacts?.percentage,
      },
      {
        label: 'Abuse',
        count: item?.statusContactsCount?.abuseContacts?.count,
        percentage: item?.statusContactsCount?.abuseContacts?.percentage,
      },
    ],
  },
  {
    label: 'Risky',
    iconClass: 'risky-icon',
    count: item?.statusContactsCount?.riskyContacts?.count,
    percentage: item?.statusContactsCount?.riskyContacts?.percentage,
    children: [
      {
        label: 'Catch-All',
        count: item?.statusContactsCount?.catchAllContacts?.count,
        percentage: item?.statusContactsCount?.catchAllContacts?.percentage,
      },
      {
        label: 'Do Not Mail',
        count: item?.statusContactsCount?.doNotMailContacts?.count,
        percentage: item?.statusContactsCount?.doNotMailContacts?.percentage,
      },
      {
        label: 'Unknown',
        count: item?.statusContactsCount?.unknownContacts?.count,
        percentage: item?.statusContactsCount?.unknownContacts?.percentage,
      },
    ],
  },
];

export const getOverlayPlacement = (
  element: HTMLElement,
  thresholdRatio = 0.5, // default: 50%
): Placement => {
  const rect = element.getBoundingClientRect();
  const screenHeight = window.innerHeight;

  const threshold = screenHeight * thresholdRatio;

  return rect.top > threshold ? Placement.TopStart : Placement.BottomStart;
};